import {translate} from "../i18n/customI18nProvider";

export const validateDate = [(value) => {
    if (value == 'Invalid Date') {
        return translate('custom.invalid_date');
    }
    return undefined;
}]